<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'task-percent-table-3';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.task-percent-table-3 {
  --header-cell-height: 45px;
  --body-cell-height: 45px;
  tbody {
    tr {
      border-top: 2pt solid #c0bec7;
      &:first-child {
        border-top: 3pt solid var(--theme-color-1);
      }
      &:last-child {
        border-bottom: 3pt solid var(--theme-color-1);
      }
    }
  }
}
</style>
